import { useMemo } from 'react'
import { useInfiniteQuery } from '@tanstack/react-query'

import { getExploreCategories } from '@/services/categories'
import { flattenPages } from '@/utils/flattenPages'

export const useExploreCategories = ({
  enabled = true,
}: {
  enabled?: boolean
} = {}) => {
  const { data, isLoading, fetchNextPage, isFetchingNextPage, refetch } =
    useInfiniteQuery({
      queryKey: ['explore_categories'],
      queryFn: ({ pageParam }) => getExploreCategories({ next: pageParam }),
      getNextPageParam: (lastPage) => lastPage?.next,
      enabled,
      initialPageParam: '',
    })

  const exploreCategories = useMemo(
    () =>
      flattenPages(data, 'items').filter((item) => item.activities.length >= 3),
    [data]
  )

  return {
    exploreCategories,
    isLoading,
    refetch,
    fetchNextPage,
    isFetchingNextPage,
  }
}
